import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export interface PrimBadge {
  icon: string;
  i18nKey: string;
  /** Valeurs interpolées dans le libellé — le palier, par exemple. */
  i18nParams?: Record<string, unknown>;
  color: string;
  locked: boolean;
}

@Component({
  selector: 'app-prim-badges-card',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './prim-badges-card.component.html',
  styleUrl: './prim-badges-card.component.css',
})
export class PrimBadgesCardComponent {
  @Input() badges: PrimBadge[] = [];
  @Input() titleKey: string = 'DASHBOARD.PRIMARY.BADGES_TITLE';
  @Input() noteKey: string = 'DASHBOARD.PRIMARY.BADGES_NOTE';
}
